import type { quoteDetail as enQuoteDetail } from "../en/quoteDetail";

export const quoteDetail: typeof enQuoteDetail = {
  trialGate: {
    actionError: "Il tuo periodo di prova è terminato{{suffix}} — scegli un piano per inviare, accettare o riprezzare i preventivi.",
    banner:
      "Il tuo periodo di prova è terminato{{suffix}}. Scegli un piano per inviare, accettare o riprezzare i preventivi — la visualizzazione resta disponibile.",
    choosePlanLink: "Scegli un piano",
  },
  notices: {
    counterDispatched: "Controfferta IA avviata. I suggerimenti compariranno qui non appena pronti (di solito ~10 secondi).",
    counterFailed: "Impossibile contattare il servizio di controfferta IA. Riprova, o contatta il supporto se il problema persiste.",
    suggesting: "L'IA sta calcolando i prezzi delle righe in base allo storico di questa azienda. Aggiorna tra qualche secondo per vedere i suggerimenti.",
    suggestFailed: "Impossibile avviare il calcolo dei prezzi IA. Riprova, o contatta il supporto se il problema persiste.",
    pricesApplied: "Prezzi suggeriti dall'IA applicati a questo preventivo.",
  },
  errors: {
    sendEmailFailed: "Impossibile inviare l'email del preventivo. Riprova o contatta il supporto.",
    rotateTokenWrongStatus: "Solo i preventivi INVIATI/VISUALIZZATI/ACCETTATI/RIFIUTATI/SCADUTI hanno un link acquirente da rigenerare.",
    resendCooldown: "Attendi {{wait}}s prima di reinviare allo stesso acquirente.",
    resendEmailFailed: "Impossibile reinviare l'email. Riprova o contatta il supporto.",
    notAcceptableState: "Il preventivo non è in uno stato che consente l'accettazione.",
    expiredCannotAccept: "Questo preventivo è scaduto — duplicalo in un nuovo preventivo per accettarlo ai prezzi correnti.",
    alreadyResponded: "È già stata data una risposta a questo preventivo.",
    draftOrderCreateFailed: "Impossibile creare l'ordine bozza. Riprova.",
    missingCounterOfferId: "counterOfferId mancante",
    counterOfferAlreadyApplied: "La controfferta è già stata applicata o non è stata trovata.",
    suggestPricesNotDraft: "I suggerimenti di prezzo IA sono disponibili solo sui preventivi in bozza.",
    missingSuggestionId: "suggestionId mancante",
    applyPricesNotDraft: "I prezzi possono essere applicati solo a un preventivo in bozza.",
    suggestionsAlreadyResolved: "Questi suggerimenti sono già stati applicati o ignorati.",
  },
  companyReadiness: {
    defaultCompanyName: "Questa azienda",
    bothMissing:
      "Ci siamo quasi — {{who}} ha solo bisogno di un contatto e di una sede in Shopify Admin prima che gli acquirenti possano accettare questo preventivo. Aggiungili in Aziende e il preventivo è pronto.",
    missingContactOnly:
      "Ci siamo quasi — {{who}} ha solo bisogno di un contatto in Shopify Admin prima che gli acquirenti possano accettare questo preventivo. Aggiungilo in Aziende e il preventivo è pronto.",
    missingLocationOnly:
      "Ci siamo quasi — {{who}} ha solo bisogno di una sede in Shopify Admin prima che gli acquirenti possano accettare questo preventivo. Aggiungila in Aziende e il preventivo è pronto.",
    openCompaniesLink: "Apri Aziende",
  },
  shopifyRejectedBanner: "Shopify ha rifiutato l'ordine bozza: {{messages}}",
  sendResultBanner: {
    sentDelivered: "Preventivo inviato — l'email all'acquirente è in arrivo.",
    resentDelivered: "Email reinviata all'acquirente.",
    sentNotDelivered:
      "Preventivo contrassegnato come inviato, ma l'email all'acquirente non è partita. Copia il link acquirente qui sopra per condividerlo, oppure usa “Reinvia email” una volta configurata la posta.",
    resentNotDelivered:
      "Email in coda ma la consegna non è stata confermata (controlla la configurazione di Resend). Usa “Reinvia email” per riprovare.",
  },
  rotatedBanner: {
    prefix: "Nuovo link acquirente:",
    suffix: "Il link precedente non funziona più — reinvia l'email per consegnare il nuovo link all'acquirente.",
    copyNewLinkButton: "Copia il nuovo link",
  },
  status: {
    heading: "Stato",
    noCompanyName: "(nessun nome azienda)",
  },
  buyer: {
    heading: "Acquirente",
    linkLabel: "Link acquirente: {{url}}",
    shareLinkHint:
      "Chiunque abbia questo link può visualizzare e rispondere al preventivo — condividilo direttamente se l'email non arriva.",
    viewedOnce: "Visualizzato {{count}} volta",
    viewedMany: "Visualizzato {{count}} volte",
    lastViewedSuffix: ", l'ultima il {{date}}",
    notOpenedYet: "L'acquirente non ha ancora aperto questo preventivo.",
    copyButtonDefaultLabel: "Copia il link acquirente",
    copiedLabel: "Copiato ✓",
    copyPromptMessage: "Copia il link acquirente:",
  },
  lines: {
    heading: "Righe",
    qty: "qtà {{qty}}",
    eachSuffix: "cad.",
    lineSubtotalPrefix: "riga:",
  },
  aiSuggestions: {
    heading: "Suggerimenti di prezzo IA",
    notProDescription:
      "Lascia che l'IA calcoli il prezzo di queste righe in base allo storico ordini di questa azienda — ogni suggerimento resta entro le tue regole di prezzo. Una funzione Pro.",
    upgradeToProLink: "Passa a Pro",
    refusedFallback:
      "Non c'è ancora abbastanza storico ordini per suggerire prezzi con sicurezza. Aggiungi qualche ordine per questa azienda e riprova.",
    dismissButton: "Ignora",
    modelCostLine: "{{model}} · ${{cost}}",
    withinLimitsBadge: "Entro i tuoi limiti",
    keptNoChange: "Invariato — nessuna modifica suggerita",
    applyPricesButton: "Applica prezzi",
    pricingInProgress: "Calcolo dei prezzi delle righe in corso… di solito richiede pochi secondi.",
    refreshLink: "Aggiorna",
    defaultCompanyName: "questa azienda",
    promptDescription:
      "Lascia che l'IA calcoli il prezzo di queste righe in base allo storico ordini di {{company}} — ogni suggerimento resta entro le tue regole di prezzo.",
    suggestPricesButton: "Suggerisci prezzi con l'IA",
  },
  dataSufficiencyBadge: "Sufficienza dei dati: {{level}}",
  actions: {
    heading: "Azioni",
    sendButton: "Invia all'acquirente",
    markAcceptedButton: "Segna come accettato (e crea ordine bozza)",
    resendEmailButton: "Reinvia email all'acquirente",
    rotateLinkButton: "Rigenera link acquirente (revoca + riemetti)",
    draftCounterButton: "Prepara controfferta IA",
    unlockOnGrowthBadge: "Sblocca con Growth",
    cancelButton: "Annulla preventivo",
    duplicateButton: "Duplica come nuova bozza",
    downloadPdfButton: "Scarica PDF",
    draftOrderLabel: "Ordine bozza: {{name}}",
  },
  counterOffer: {
    heading: "Controfferta IA",
    scanSummary: "{{count}} ordini analizzati · {{model}} · ${{cost}}",
    appliedBadge: "Applicata il {{date}}",
    applyButton: "Applica come nuovo preventivo",
  },
  activity: {
    heading: "Attività ({{count}})",
    actor: {
      buyer: "acquirente",
      system: "sistema",
      merchant: "commerciante",
    },
  },
};
